import { AIMethods, EmbedderConfig } from "../../../index";

export const aiTitleToEmbedder = (
  title: AIMethods,
  embeddersConfig: EmbedderConfig[],
) => embeddersConfig.find(({ aiTitle }) => aiTitle === title);
